export class ProcessCommandActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
        if (!this.to) {
            this.to = 'postmaster@msging.net';
        }
    }
}
